// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statistics-report .report-buttons{min-height:30px;padding:10%;width:80%}.statistics-report .report-buttons button{width:45%;font-size:16px;color:#9a66bf}\n", ""]);
// Exports
module.exports = exports;
